import styles from "./result.module.css";

const Result = ({
  title,
  subtitle,
  icon,
  className = "",
  iconClassName = "",
  children,
}) => {
  return (
    <div className={`${styles.result} ${className}`}>
      {icon && <div className={`${styles.icon} ${iconClassName}`}>{icon}</div>}
      {title && <h2 className={styles.title}>{title}</h2>}
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      {children}
    </div>
  );
};

export default Result;
